import {CommercialPackageState} from './CommercialPackagesState';
import {
  GET_COMMERCIAL_PACKAGES_SUCCESS,
  SharedCommercialPackagesActionsType,
} from './SharedCommercialPackagesActions';

const initialState: CommercialPackageState = {
  data: [],
};

export const sharedCommercialPackagesReducer = (
  state: CommercialPackageState = initialState,
  action: SharedCommercialPackagesActionsType,
): CommercialPackageState => {
  switch (action.type) {
    case GET_COMMERCIAL_PACKAGES_SUCCESS:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};
